module.exports = __webpack_public_path__ + "img/right_class.14d10e93.png";